import { formatDistance } from 'date-fns';

// --- HELPER: POYA CALCULATOR ---
const isPoyaDay = (dateObj) => {
    const knownFullMoon = new Date('2024-01-25T17:54:00Z').getTime();
    const nowTime = dateObj.getTime();
    const msPerCycle = 29.53059 * 86400000;
    const diff = nowTime - knownFullMoon;
    const cycles = diff / msPerCycle;
    const pos = cycles - Math.floor(cycles);
    return pos < 0.03 || pos > 0.97;
};

// --- HELPER: DEEPAVALI LOOKUP ---
const getDeepavaliDate = (year) => {
    const dates = { 2025: '10-20', 2026: '11-08', 2027: '10-29', 2028: '10-17', 2029: '11-05' };
    return dates[year] || '11-12';
};

// --- COLOR PALETTE ---
const COLORS = {
    BARAKAH_GREEN: '#006A4E', // Deep, spiritual green
    RICH_GOLD: '#FFD700',
    PURE_WHITE: '#ffffff',
    KAABA_BLACK: '#1a1a1a'
};

// 🌙 TEST RAMADAN START (Today!)
//const data = getSmartEventData(userJoinedDate, '2026-02-18'); 

// 🕌 TEST EID-UL-FITR
//const data = getSmartEventData(userJoinedDate, '2026-03-20'); 

// 🥥 TEST AVURUDU
//const data = getSmartEventData(userJoinedDate, '2026-04-13'); 

// 🌕 TEST POYA (Vesak style - May)
//const data = getSmartEventData(userJoinedDate, '2026-05-31'); 

// 🎄 TEST CHRISTMAS
//const data = getSmartEventData(userJoinedDate, '2026-12-25'); 

// 🇱🇰 TEST INDEPENDENCE DAY
//const data = getSmartEventData(userJoinedDate, '2026-02-04'); 

// 🕋 TEST HAJJ (Eid-ul-Adha)
//const data = getSmartEventData(userJoinedDate, '2026-06-16');

export const getSmartEventData = (userJoinedDate = '2025-01-01', overrideDate = null, userName = 'there') => {
    const now = overrideDate ? new Date(overrideDate) : new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const date = now.getDate();
    const todayStr = now.toISOString().split('T')[0];

    // 1. TENURE
    const yearsWithUs = formatDistance(new Date(userJoinedDate), now);

    // 2. ISLAMIC CALENDAR ENGINE (Base 2024 Anchors)
    const daysShift = Math.floor((year - 2024) * 10.875);
    const msShift = daysShift * 86400000;
    console.log("msShift", msShift)
    // 🔴 FIX: Use `${year}` instead of '2024' for the base, THEN subtract the shift
    // This projects the Gregorian anchor into the current year before applying the Lunar drift.

    // Base: March 11 (Approx start of Ramadan relative to solar year)
    const estRamadanStart = new Date(new Date(`${year}-03-11`).getTime() - msShift);

    // Base: April 10
    const estEidFitr = new Date(new Date(`${year}-04-10`).getTime() - msShift);

    // Base: June 17
    const estEidAdha = new Date(new Date(`${year}-06-17`).getTime() - msShift);

    // Base: July 07
    const estIslamicNewYear = new Date(new Date(`${year}-07-07`).getTime() - msShift);

    // Base: Sept 16
    const estMilad = new Date(new Date(`${year}-09-16`).getTime() - msShift);

    // --- PRIORITY 1: THE BIG "NEW YEARS" ---

    // A. GREGORIAN NEW YEAR (Jan 1)
    if (month === 0 && date === 1) {
        return {
            id: `newyear-global-${year}`,
            title: `Happy New Year ${year}, ${userName}!`,
            founderMsg: `Page 1 of 365. Let's write a successful story together this year, ${userName}.`,
            theme: { symbols: ['🎉', '🥂', '🎆', '✨'], colors: ['#FFD700', '#000000', '#ffffff'], count: 80 }
        };
    }

    // B. SINHALA & TAMIL NEW YEAR (Apr 13-14)
    if (month === 3 && (date === 13 || date === 14)) {
        return {
            id: `avurudu-${year}`,
            title: `Happy Avurudu, ${userName}!`,
            founderMsg: `May this New Year bring prosperity to your shop, ${userName}! Proud to support you for ${yearsWithUs}.`,
            theme: { symbols: ['🪔', '🍃', '☀️', '🥥'], colors: ['#ff4d4d', '#ffff00', '#32CD32'], count: 50 }
        };
    }

    // C. ISLAMIC NEW YEAR (Awal Muharram)
    if (Math.abs(now - estIslamicNewYear) < 86400000) {
        return {
            id: `islamic-newyear-${year}`,
            title: `Hijri New Year Mubarak, ${userName}!`,
            founderMsg: `May this new year bring Barakah to your business and family, ${userName}.`,
            theme: {
                symbols: ['🌙'],
                colors: [COLORS.BARAKAH_GREEN, COLORS.RICH_GOLD, COLORS.PURE_WHITE],
                count: 10
            }
        };
    }

    // --- PRIORITY 2: RELIGIOUS FESTIVALS ---

    // D. RAMADAN START
    if (now >= estRamadanStart && now <= new Date(estRamadanStart.getTime() + (3 * 86400000))) {
        return {
            id: `ramadan-start-${year}`,
            title: `Ramadan Kareem, ${userName}!`,
            founderMsg: `Wishing you a blessed month, ${userName}. Thank you for being with us for ${yearsWithUs}.`,
            theme: {
                symbols: ['🌙'],
                colors: [COLORS.BARAKAH_GREEN, COLORS.RICH_GOLD],
                count: 10
            }
        };
    }
    // E. EID-UL-FITR
    if (Math.abs(now - estEidFitr) < 172800000) {
        return {
            id: `eid-fitr-${year}`,
            title: `Eid Mubarak, ${userName}!`,
            founderMsg: `May this Eid bring joy to your heart and success to your business, ${userName}.`,
            theme: {
                symbols: ['🌙'],
                colors: [COLORS.BARAKAH_GREEN, COLORS.PURE_WHITE, COLORS.RICH_GOLD],
                count: 10
            }
        };
    }

    // F. EID-UL-ADHA (Hajj)
    if (Math.abs(now - estEidAdha) < 172800000) {
        return {
            id: `eid-adha-${year}`,
            title: `Eid-ul-Adha Mubarak, ${userName}!`,
            founderMsg: `On this day of sacrifice, we appreciate your dedication and partnership, ${userName}.`,
            theme: {
                symbols: ['🕋', '🐐', '🌙'],
                colors: [COLORS.KAABA_BLACK, COLORS.BARAKAH_GREEN, COLORS.RICH_GOLD],
                count: 45
            }
        };
    }

    // G. MILAD-UN-NABI
    if (Math.abs(now - estMilad) < 86400000) {
        return {
            id: `milad-${year}`,
            title: `Milad-un-Nabi Mubarak, ${userName}!`,
            founderMsg: `Sending you warm wishes on this blessed day, ${userName}.`,
            theme: {
                symbols: ['💚', '🕌', '✨'],
                colors: [COLORS.BARAKAH_GREEN, '#90EE90', COLORS.PURE_WHITE],
                count: 35
            }
        };
    }

    // H. THAI PONGAL
    if (month === 0 && date === 14) {
        return {
            id: `pongal-${year}`,
            title: `Happy Thai Pongal, ${userName}!`,
            founderMsg: `Harvesting success together, ${userName}!`,
            theme: { symbols: ['🌾', '🍯', '☀️'], colors: ['#FFD700', '#FFA500'], count: 40 }
        };
    }

    // I. DEEPAVALI
    const deepavaliDate = getDeepavaliDate(year);
    if (todayStr.includes(deepavaliDate)) {
        return {
            id: `deepavali-${year}`,
            title: `Happy Deepavali, ${userName}!`,
            founderMsg: `May the festival of lights brighten your business journey, ${userName}.`,
            theme: { symbols: ['🪔', '✨', '🎆'], colors: ['#FF8C00', '#FF00FF', '#FFFF00'], count: 10 }
        };
    }

    // J. CHRISTMAS
    if (month === 11 && (date === 24 || date === 25)) {
        return {
            id: `xmas-${year}`,
            title: `Merry Christmas, ${userName}!`,
            founderMsg: `Wishing you peace and profit this season, ${userName}!`,
            theme: { symbols: ['❄️'], colors: ['#cf0000ff', '#ff0000'], count: 10 }
        };
    }

    // K. INDEPENDENCE DAY
    if (month === 1 && date === 4) {
        return {
            id: `independence-${year}`,
            title: `Happy Independence Day, ${userName}!`,
            founderMsg: `Proud to build for Sri Lanka, with you, ${userName}.`,
            theme: { symbols: ['\u{1F1F1}\u{1F1F0}', '🦁'], colors: ['#8D153A', '#EB7400', '#006D56', '#ffbe00'], count: 10 }
        };
    }

    // --- PRIORITY 3: MONTHLY / ONGOING ---

    // L. RAMADAN MONTH (Effects Only)
    if (now > estRamadanStart && now < estEidFitr) {
        return {
            id: `ramadan-month-${year}`,
            title: `Ramadan Mubarak, ${userName}!`,
            founderMsg: null,
            theme: { symbols: ['🌙', '⭐'], colors: ['#FFD700', '#ffffff'], count: 20 }
        };
    }

    // M. POYA DAY
    if (isPoyaDay(now)) {
        let poyaName = `Full Moon Poya Day, ${userName}`;
        let poyaColors = ['#ffffff', '#fffce0'];
        if (month === 4) { poyaName = `Happy Vesak Poya, ${userName}`; poyaColors = ['#0000FF', '#FFFF00', '#FF0000', '#FFFFFF', '#FF9900']; }
        if (month === 5) poyaName = `Happy Poson Poya, ${userName}`;

        return {
            id: `poya-${year}-${month}`,
            title: poyaName,
            founderMsg: `May the triple gem bless your business, ${userName}.`,
            theme: { symbols: ['☸️', '🌸', '🌕'], colors: poyaColors, count: 35 }
        };
    }

    return null;
};